import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs'
@Injectable({
  providedIn: 'root'
})
export class SharedserviceService {
  private baseUrl = environment.apiUrl;
  private ssoUrl = environment.ssoUrl;
  constructor(private http: HttpClient, private router: Router) { }

  getapplications() {
    return this.http.get<any>(`${this.baseUrl}api/apps`)
      .pipe(map(data => {
          return data
      }));
  }
  getclients() {
    // const headers = new HttpHeaders({
    //   'x-access-token':token
    //   });

    return this.http.get<any>(`${this.baseUrl}api/clients`)
      .pipe(map(data => {
          return data
      }));
  }


  pageLevelPermissions(appname,username,client,pageName,role){
    return this.http.post<any>(`${this.baseUrl}api/getPageLevelPermission`,{
      userName: localStorage.getItem('userName')+localStorage.getItem('firstName'),
      appName:appname,
      client:client,
      pageName:pageName,
      role:role
    })
    .pipe(map(data => {
        return data
    }),        catchError(errorRes => {
      // console.log(errorRes)
      let errormessage = 'An error Occured';
      if (!errorRes.error || !errorRes.error.message) {

        return throwError(errormessage)
      }
      return throwError(errormessage)
    }));
  }
  pageLevelSSOPermissions( role,client,appname) {
    return this.http.get<any>(
      `${this.ssoUrl}/api/application/pagesOfRole?roleName=${role}&applicationName=${appname}&clientName=${client}`
    ).pipe(
      map(data => {
        return data;
      }),
      catchError(errorRes => {
        let errorMessage = 'An error occurred';
        if (!errorRes.error || !errorRes.error.message) {
          return throwError(errorMessage);
        }
        return throwError(errorMessage);
      })
    );
  }
  
  

}
